let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f95gj")).then(() => parcelRequire('ggsS6'));